import React, { useState, useEffect, useRef } from "react"
import clsx from "clsx"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, Hidden, useMediaQuery } from "@material-ui/core"
import { showGuides } from "@src/utils/debug"
import FluidImage from "../components/FluidImage"
import Module from "../components/Module"
import Text from "../components/Text"
import ShowMoreText from "../components/ShowMoreText"
import Parallax from "../components/Parallax"
import { useInView } from "react-intersection-observer"
import { Parallax as ParallaxItem } from "react-scroll-parallax"

const parallaxHeight = 400
const containerHeight = 540
const imageMaxHeightRatio = 1.35
const safeguard = 10
const safeguardSensibility = 2
const lowerSensibility = 200
const upperSensibility = 100
const useStyles = makeStyles(theme => ({
  simpleContent: {},
  containerWrapper: {
    display: "block",
    position: "absolute",
    top: `${(parallaxHeight * imageMaxHeightRatio) / 2}px`,
    //transform: `translate3d(0, -${parallaxHeight/2}px, 0)`
  },
  contentContainer: {
    display: "flex",
    //flexDirection: 'row',
    position: "relative",
    minHeight: containerHeight,
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      paddingLeft: 0,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      float: "initial !important",
    },
  },
  extraMargin: {
    marginBottom: "100px!important",
  },
  editorialContent: {
    width: "40%",
    //marginLeft: 'auto',
    //height: 'fit-content',
    //paddingTop: (containerHeight - parallaxHeight) * 0.5, // + theme.spacing(6),
    //marginBottom: 'auto',
    display: "flex",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      paddingTop: 0,
      marginLeft: "initial",
    },
  },
  editorialContentInner: {
    marginTop: "auto",
    marginBottom: "auto",
    paddingLeft: theme.spacing(6),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
  },
  title: {
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
    "&:before": {
      [theme.breakpoints.down("md")]: {
        marginLeft: "auto",
        marginRight: "auto",
      },
    },
  },
  text: {
    paddingTop: theme.spacing(4),
    paddingRight: theme.spacing(8),
    [theme.breakpoints.down("md")]: {
      width: "100%",
      textAlign: "center",
      padding: theme.spacing(4),
    },
  },
  anchor: {
    ...theme.fonts.faces.bodyXS,
    ...theme.fonts.weights.bold,
    color: "black !important",
    borderBottom: `3px solid ${theme.customPalette.tangerine}`,
  },
  imageWrapper: {
    //border: showGuides('4px dashed green'),
    border: "1px solid transparent",
    position: "relative",
    width: "57%",
    float: "left",
    display: "flex",
    //maxHeight: parallaxHeight * imageMaxHeightRatio,
    maxHeight: containerHeight,
    //top: parallaxHeight/2,
    //transform: 'translate3d(0,-50%,0)',
  },
  parallaxWrapper: {
    position: "absolute",
    border: showGuides("2px solid magenta"),
    left: -theme.spacing(8),
    right: -theme.spacing(0),
    zIndex: -1,
    //width: '100%',
    height: `${parallaxHeight}px`,
    top: "0%",
    //top: '50%',
    //transform: 'translate3d(0, -50%, 0)',
    //maxHeight: '400px',
    /* top: 0,
        bottom: 0,
        height: '100%',
        right: theme.spacing(8),
        left: '-25vw',
        margin: 'auto',
        zIndex: -1,*/
  },
  foregroundWrapper: {},
  parallax: {
    border: showGuides("2px dashed gray"),
  },
  background: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "85%",
    zIndex: -1,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    [theme.breakpoints.down("md")]: {
      height: "100%",
      width: "120%",
      left: "-10%",
      top: "50%",
      transform: "translate3d(0,-50%,0)",
      backgroundSize: "100%",
      backgroundPosition: "center top",
    },
  },
  foreground: {
    //height: 'fit-content',
    maxHeight: containerHeight,
    width: "100%",
    textAlign: "right",
    marginLeft: "auto",
    [theme.breakpoints.down("md")]: {
      minHeight: 400,
      maxWidth: 500,
      height: "100%",
      width: "100%",
      margin: "0 auto",
    },
  },
  parallaxItem: {
    //position: 'absolute',
    //top: '50%',
    right: 0,
    //transform: 'translate3d(0, -50%, 0)'
  },
  fixedImage: {
    position: "fixed",
    left: -613,
    //top: 100
  },
  foregroundContainer: {
    position: "relative",
  },
  fixedImage2: {
    position: "fixed",
  },
  fixedImageContainer: {},
  innerImage: {
    width: "100%",
    maxHeight: containerHeight,
  },
  fluidBackground: {
    width: "inherit",
    height: "inherit",
  },
}))

const SimpleContentModule = ({
  title,
  text,
  foregroundImage,
  backgroundImage,
  mobileBackgroundImage,
  readMoreText,
  readLessText,
  lines,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  /*if(true){
        title= 'About the model';
        text= 'An incredible collection with the most relevant characters of the Star Wars saga. \n High quality 15 cm figures, made of natural resins and hand-painted. \n An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. \n \n \nAn incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted.\n High quality 15 cm figures, made of natural resins and hand-painted. \n An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted. An incredible collection with the most relevant characters of the Star Wars saga. High quality 15 cm figures, made of natural resins and hand-painted.\n';
        backgroundImage= {
          title: 'image title',
          alt: 'image alt',
          src: 'https://d24udp600h4lxn.cloudfront.net/fh/live/media/about-this-background/about-this-background_optmzd_80.png',
          webp: 'https://d24udp600h4lxn.cloudfront.net/fh/live/media/about-this-background/about-this-background_optmzd_80.png',
        };
        mobileBackgroundImage= {
          title: 'image title',
          alt: 'image alt',
          src: 'https://d24udp600h4lxn.cloudfront.net/fh/live/media/about-this-background/about-this-background_optmzd_80.png',
          webp: 'https://d24udp600h4lxn.cloudfront.net/fh/live/media/about-this-background/about-this-background_optmzd_80.png',
        };
        lines= 10;
        readMoreText= 'READ MORE';
        readLessText= 'READ LESS';
    }*/

  const [visible, setVisible] = useState(false)
  const [target, setTarget] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const [fixImage, _setFixImage] = useState(false)
  const [difference, _setDifference] = useState(0)
  const [archor, _setArchor] = useState(true)

  const archorListener = React.useRef(archor)
  const setArchor = data => {
    archorListener.current = data
    _setArchor(data)
  }
  const fixImageListener = React.useRef(fixImage)
  const setFixImage = data => {
    fixImageListener.current = data
    _setFixImage(data)
  }
  const differenceListener = React.useRef(difference)
  const setDifference = data => {
    differenceListener.current = data
    _setDifference(data)
  }

  //const {ref, inView, entry} = useInView()
  const reference = useRef(null)
  const refImage = useRef(null)
  const refImage2 = useRef(null)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const handleScroll = e => {
    if (isMobile) return
    if (!e) {
      e = {
        target: document,
      }
    }
    if (reference.current && refImage.current && fixImageListener.current) {
      var elDistanceToTop = reference.current.getBoundingClientRect().top
      var imageDistaceToTop = refImage.current.getBoundingClientRect().top
      var elDistanceToBottom = reference.current.getBoundingClientRect().bottom
      var imageDistaceToBottom = refImage.current.getBoundingClientRect().bottom
      //var containerHeight = reference.current.clientHeight;
      var imageHeight = refImage.current.clientHeight
      const viewportHeight = window.innerHeight

      if (archorListener.current) {
        if (
          (elDistanceToTop >= 0 &&
            imageDistaceToTop >= 0 &&
            elDistanceToTop <= imageDistaceToTop &&
            imageDistaceToTop - elDistanceToTop > differenceListener.current) ||
          (imageDistaceToTop >= 0 &&
            elDistanceToTop >= 0 &&
            imageDistaceToTop < upperSensibility) ||
          (imageDistaceToTop < 0 && elDistanceToBottom > imageDistaceToBottom)
        ) {
          refImage.current.style.top = refImage.current.style.top
            ? refImage.current.style.top
            : (imageDistaceToTop < upperSensibility
                ? upperSensibility + 1
                : imageDistaceToTop) + "px"
          refImage.current.style.left = refImage.current.style.left
            ? refImage.current.style.left
            : refImage.current.getBoundingClientRect() + "px"
          setArchor(false)
          if (refImage2 && refImage2.current) {
            refImage2.current.style.top = refImage2.current.style.top
              ? refImage2.current.style.top
              : refImage.current.getBoundingClientRect().top + "px"
            refImage2.current.style.width = refImage2.current.style.width
              ? refImage2.current.style.width
              : refImage2.current.clientWidth + "px"
            refImage2.current.style.height = refImage2.current.style.height
              ? refImage2.current.style.height
              : refImage2.current.clientHeight + "px"
          }
        } else if (
          !(elDistanceToTop >= 0 && imageDistaceToTop >= 0) &&
          viewportHeight - imageDistaceToBottom > 0 &&
          viewportHeight - imageDistaceToBottom < lowerSensibility
        ) {
          refImage.current.style.top =
            viewportHeight -
            imageHeight -
            (lowerSensibility + safeguardSensibility) +
            "px"
          refImage.current.style.left = refImage.current.style.left
            ? refImage.current.style.left
            : refImage.current.getBoundingClientRect() + "px"
          setArchor(false)
          if (refImage2 && refImage2.current) {
            refImage2.current.style.top =
              viewportHeight -
              refImage.current.clientHeight -
              (lowerSensibility + safeguardSensibility) +
              "px"
            refImage2.current.style.width = refImage2.current.style.width
              ? refImage2.current.style.width
              : refImage2.current.clientWidth + "px"
            refImage2.current.style.height = refImage2.current.style.height
              ? refImage2.current.style.height
              : refImage2.current.clientHeight + "px"
          }
        }
      } else {
        if (
          elDistanceToTop >= 0 &&
          imageDistaceToTop >= 0 &&
          elDistanceToTop > imageDistaceToTop
        ) {
          refImage.current.style.top = ""
          refImage.current.style.left = ""
          setArchor(true)
          if (refImage2 && refImage2.current) {
            refImage2.current.style.top = ""
            refImage2.current.style.width = ""
            refImage2.current.style.height = ""
          }
        } else if (elDistanceToBottom <= imageDistaceToBottom) {
          refImage.current.style.top =
            reference.current.clientHeight -
            refImage.current.clientHeight +
            "px"
          refImage.current.style.left = ""
          setArchor(true)
          if (refImage2 && refImage2.current) {
            refImage2.current.style.top =
              reference.current.clientHeight -
              refImage.current.clientHeight +
              "px"
            refImage2.current.style.width = ""
            refImage2.current.style.height = ""
          }
        }
      }
    }
  }

  useEffect(() => {
    if (reference && reference.current && refImage && refImage.current) {
      setDifference(
        reference.current.getBoundingClientRect().top -
          refImage.current.getBoundingClientRect().top +
          safeguard
      )
    }
  }, [reference, refImage, reference.current, refImage.current])

  useEffect(() => {
    if (!fixImage) {
      setTimeout(() => {
        // Remove first to avoid unhandled renders
        window.removeEventListener("scroll", handleScroll)
        window.addEventListener("scroll", handleScroll)
      }, 100) // detach from initial render to improve page speed
    }
  }, [])

  const onVisible = visibility => {
    if (!visible && visibility) {
      setVisible(visibility) // just once
    }
  }

  const handleOnEllipsisInit = e => {
    var target = e.current.parentElement.parentElement
    setTarget(target)
  }

  const handleOnChange = expand => {
    setExpanded(expand)
    setFixImage(expand)
    //handleScroll();
    setArchor(!expanded)
    if (expanded) {
      if (refImage.current) {
        refImage.current.style.top = ""
      }
      if (refImage2.current) {
        refImage2.current.style.top = ""
      }
    } else {
      var imageDistaceToTop
      if (refImage.current) {
        imageDistaceToTop = refImage.current.getBoundingClientRect().top
        refImage.current.style.top = refImage.current.style.top
          ? refImage.current.style.top
          : (imageDistaceToTop < upperSensibility
              ? upperSensibility + 1
              : imageDistaceToTop) + "px"
        //refImage.current.style.top = (refImage.current.style.top ? refImage.current.style.top: reference.current.getBoundingClientRect().top);
      }
      if (refImage.current && refImage2.current) {
        refImage2.current.style.top = refImage2.current.style.top
          ? refImage.current.style.top
          : (imageDistaceToTop < upperSensibility
              ? upperSensibility + 1
              : imageDistaceToTop) + "px"
        //refImage2.current.style.top = (refImage2.current.style.top ? refImage2.current.style.top: reference.current.getBoundingClientRect().top);
      }
    }
  }

  const hasBothImages = foregroundImage && backgroundImage

  return (
    <Module
      className={clsx(
        classes.simpleContent,
        fixImage && !isMobile ? classes.extraMargin : ""
      )}
      classes={{ container: classes.contentContainer }}
      variant="right"
      onVisibilityChange={onVisible}
    >
      <Hidden mdDown>
        <Box
          className={clsx(
            classes.imageWrapper,
            fixImage && !archor ? classes.fixedImageContainer : ""
          )}
        >
          {hasBothImages ? (
            <div
              ref={refImage2}
              className={clsx(
                classes.foregroundContainer,
                fixImage && !archor ? classes.fixedImage2 : ""
              )}
            >
              <FluidImage
                className={clsx(classes.foreground)}
                innerClassName={classes.innerImage}
                avoidExtraAnimation={fixImage && !archor}
                {...foregroundImage}
              ></FluidImage>
            </div>
          ) : (
            ""
          )}
          <Box
            ref={refImage}
            className={clsx(
              classes.parallaxWrapper,
              fixImage && !archor ? classes.fixedImage : ""
            )}
          >
            <FluidImage
              className={classes.fluidBackground}
              {...(backgroundImage
                ? backgroundImage
                : foregroundImage
                ? foregroundImage
                : "")}
            ></FluidImage>
          </Box>
        </Box>
      </Hidden>
      <Box ref={reference} className={classes.editorialContent}>
        <Box
          className={classes.editorialContentInner}
          style={{ marginTop: expanded ? `${target.offsetTop}px` : "auto" }}
        >
          <Text
            className={classes.title}
            variant="titleXXXL"
            overline
            weight="bold"
          >
            {title}
          </Text>
          {visible && (
            <ShowMoreText
              className={classes.text}
              variant="bodyM"
              readMoreText={readMoreText}
              readLessText={readLessText}
              onEllipsisInit={handleOnEllipsisInit}
              onChange={handleOnChange}
            >
              {text}
            </ShowMoreText>
          )}
          <Hidden lgUp>
            <div style={{ position: "relative", width: "100%" }}>
              <div
                className={clsx(classes.background, "lazyload")}
                data-bg={mobileBackgroundImage ? mobileBackgroundImage.src : ""}
              ></div>
              <FluidImage
                className={classes.foreground}
                {...foregroundImage}
              ></FluidImage>
            </div>
          </Hidden>
        </Box>
      </Box>
    </Module>
  )
}

export default SimpleContentModule
